import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { SPACE } from '@utils/constants';
import { SubText } from '../components/shared';

export const TotalOtherText = ({
  count,
  onClick,
  forceMobileView,
}: {
  count: number;
  onClick?: () => void;
  forceMobileView: boolean;
}) => {
  return (
    <>
      <SubText forceMobileView={forceMobileView}>
        {SPACE}
        and
      </SubText>
      {SPACE}
      <ModalButton forceMobileView={forceMobileView} onClick={onClick}>
        {count} more
      </ModalButton>
    </>
  );
};

export const ModalButton = styled('button', {
  base: 'S',
  outline: 'none',
  border: 'none',
  fontStyle: 'semibold',
  color: '$neutral900',
  cursor: 'pointer',

  '@tablet': {
    base: 'M',
    fontStyle: 'semibold',
    color: '$neutral900',
  },

  '@tabletLandscape': {
    base: 'L',
    fontStyle: 'semibold',
    color: '$neutral900',
  },

  '&:hover': {
    color: '$neutral500',
  },

  variants: {
    forceMobileView: {
      true: {
        base: 'S',
      },
    },
  },
});
